import toast from 'react-hot-toast';
import { Episode } from '../models/podcasts';
import { BumpPriorityAction, fetchEpisode } from './api';
import { reportSentryError, reportSentryWarning } from './sentry';

export { reportSentryError, reportSentryWarning };

//
// Handle audio not loading & playing
//

export async function checkEpisodeAfterFailure(
  episode: Episode,
  action: BumpPriorityAction
) {
  const {
    status,
    episode: { isSaved },
  } = await fetchEpisode(episode.podcastId, episode.guidHash, action);
  let retryInSeconds;
  if (isSaved) retryInSeconds = 0;
  // else if (status === 'saving_audio_file') retryInSeconds = 5; // No longer used
  else if (status === 'pending') retryInSeconds = 10;
  return { status, isSaved, retryInSeconds };
}

export async function showMessageWhenPlaybackFails(
  isSaved: boolean,
  status: string | undefined,
  action: 'play' | 'download'
) {
  toast.error(
    `Failed to ${action} audio. Please check your internet connection and try again`
  );
}
